export const isRequestInFlight = (requestName) => (state) => state.http.getIn([requestName, 'isInFlight'], false);

export default isRequestInFlight;



// WEBPACK FOOTER //
// ./selectors/httpSelectors/httpSelectors.js